var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticStyle: { position: "relative" } },
    [
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.isShow,
              expression: "isShow"
            }
          ],
          staticClass: "tips"
        },
        [
          _vm.xaizai
            ? _c("div", { on: { click: _vm.downLoad } }, [
                _c("img", {
                  attrs: {
                    src: require("../../../../../static/images/downloadicon.png"),
                    alt: ""
                  }
                }),
                _vm._v("\n      下载\n    ")
              ])
            : _vm._e(),
          _vm._v(" "),
          _c("div", { on: { click: _vm.operationFn } }, [
            _c("img", {
              attrs: {
                src: require("../../../../../static/images/yulanicon.png"),
                alt: ""
              }
            }),
            _vm._v("\n      预览\n    ")
          ])
        ]
      ),
      _vm._v(" "),
      _vm._t("default"),
      _vm._v(" "),
      _vm.videoSrc
        ? _c("video-preview", {
            attrs: { videoSrc: _vm.videoSrc, videoName: _vm.videoName },
            on: { closeFn: _vm.closeVideoPreview }
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.imgSrc
        ? _c("imgView", {
            attrs: { imgSrc: _vm.imgSrc, imgName: _vm.imgName },
            on: { closeFn: _vm.closeImgview }
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.audioSrc
        ? _c("audioView", {
            ref: "audio",
            attrs: { audioSrc: _vm.audioSrc, audioName: _vm.audioName },
            on: { closeFn: _vm.closeaudioView }
          })
        : _vm._e()
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-3975b1b3", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3975b1b3","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/szrt_revision/teachingDetail/components/ToolTip.vue
// module id = null
// module chunks = 